module.exports = __webpack_public_path__ + "static/sport/bgi-mobile.768bb48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-mobile.png
// module id = ioh/
// module chunks = 0